export default "__VITE_ASSET__BT0yhzA3__"